<div class="container-fluid mt-5">
  <div class="row">
    <div class="d-flex">
      <div *ngFor="let plugin of taskModel.plugins">
        <mat-card class="task-selector-card h-100 m-2">
          <img (click)="createNewTask(plugin)" [src]="plugin.thumbnailBlobUrl" class="plugin-card-image" />
          <div class="task-selector-card-content">
            <mat-card-content class="plugin-card-description">
              {{plugin.description}}
            </mat-card-content>
            <mat-card-actions class="d-flex justify-content-center">
              <button (click)="createNewTask(plugin)" mat-raised-button color="primary">CREATE NEW TASK</button>
            </mat-card-actions>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
